import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  DatePicker,
  InputItem,
  Picker,
  Toast,
} from "antd-mobile-v2";
import "./index.less";
import React, { Component } from "react";
import { createForm } from "rc-form";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import allUrl from "../../api/allUrl";
import tool from "../../api/tool";
import { getCity } from "../../public/getCityData";
import { userInfoData } from "../../public/getUserInfo";
import sectioValue from "../../api/service/secsstion";
import {
  GenderData,
  formInputData,
  getDocType,
  getQuestion,
  nation_data,
  getJobData,
  idTypeData,
  getUserType,
} from "./const";
import moment from "moment";
import { sm4 } from "sm-crypto";
import publicKey from "../../constants/publicKey";

const Item = List.Item;
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
const maxDate = new Date();
const minDate = new Date(1960, 1, 1, 0, 0, 0);
const joinData = ["idType", "userSex"];
let idVal =
  /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
      applyType: "reg",
      docType: idTypeData, // 证件类型数据
      cityData: [], // 城市数据
      questionData: [], // 密保问题数据
      date: now, // 当前的时间
      jobData: [], // 职业数据
      imageKey: {},
      getUserType: [], // 人员类型数据
      userInfoData: {},
      type: "resister", // 当前是什么操作 // 注册新用户regisrer还是修改个人信息edit
    };
  }
  // 倒计时
  countDown = () => {
    const { count, flagCode } = this.state;
    let timer = null;
    let num = count;
    this.setState({
      flagCode: false,
    });
    timer = setInterval(() => {
      if (num <= 1) {
        clearInterval(timer);
        num = 60;
        this.setState({
          flagCode: true,
        });
      }
      num--;
      this.setState({
        count: num,
      });
    }, 1000);
  };
  // 获取图片验证码
  getImageCode = () => {
    get(allUrl.register.getImageCode, {})
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let imgKey = res.data.key || "";
          let imageUrl = res.data.image || "";
          this.setState({
            imageKey: {
              imageKey: imgKey,
              imageUrl: imageUrl,
            },
          });
        } else {
          Toast.info(res.data.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info("验证码获取失败，请重试", 1);
      });
  };
  validateIdVal = (rule, value, callback) => {
    if (idVal.test(value)) {
      let birthData = this.idCard(value);
      let num = moment(birthData);
      this.props.form.setFieldsValue({
        userBrith: num["_d"],
      });
    }
    callback();
  };
  idCard = (userCard) => {
    let birth =
      userCard.substring(6, 10) +
      "-" +
      userCard.substring(10, 12) +
      "-" +
      userCard.substring(12, 14);
    return birth;
  };
  // 获取验证码
  catchapCode = () => {
    const { flagCode } = this.state;
    let phoneS = this.props.form.getFieldValue("phoneNumber");
    let imageCode = this.props.form.getFieldValue("imageCode");
    if (!imageCode) {
      Toast.fail("请输入图片验证码", 1);
      return;
    }
    if (!phoneS) {
      Toast.fail("请输入手机号", 1);
      return;
    }
    if (!flagCode) {
      return;
    }
    // 验证图片验证码
    headerGet(
      allUrl.register.captchaImage,
      {},
      { "Captcha-Code": imageCode, "Captcha-Key": this.state.imageKey.imageKey }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        this.getPhoneCode(phoneS);
      } else {
        Toast.fail(res.msg, 1, () => {
          this.getImageCode();
        });
      }
    });
  };
  // 获取手机验证码
  getPhoneCode = (phoneS) => {
    get(allUrl.register.getPhoneCode, { phone: phoneS })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          this.countDown();
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("验证码获取失败", 1);
      });
  };
  // 数据提交
  onSubmit = () => {
    const { questionData, jobData, docType } = this.state;
    this.props.form.validateFields({ force: true }, (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      joinData.forEach((item) => {
        values[item] = values[item].join("");
      });
      let userJobnName = jobData.filter((item) => {
        return item.value == values["userJob"][0];
      });
      let nationName = nation_data.filter((item) => {
        return item.value == values["userNational"][0];
      });
      let idTypeName = docType.filter((item) => {
        return item.value == values["idType"];
      });
      console.log(values, "注册时的所有数据");
      values["teamTypeParent"] = values["teamTypeParent"][0];
      values["idTypeVal"] = idTypeName[0].label;
      if (userJobnName.length > 0) {
        values["userJob"] = userJobnName[0].label;
      }
      values["userNational"] = nationName[0].label;
      values["userBrith"] = moment(values["userBrith"]).format("YYYY-MM-DD");
      let userCode = sectioValue.get("acount");
      
      values["confirm"] = sm4.encrypt(values.confirm, publicKey)
      values["userPassword"] = sm4.encrypt(values.userPassword, publicKey)
      if (!userCode) {
        let questionName = questionData.filter((item) => {
          return item.value == values["pwdQuestionOne"][0];
        });
        values["pwdQuestionOne"] = questionName[0].label;
        this.submitData(values);
      } else {
        console.log("修改个人信息");
        this.editData(values);
      }
    });
  };
  // 修改个人信息
  editData = (data) => {
    data["userProvince"] = data["address"][0]; // 省
    data["userCity"] = data["address"][1]; // 市
    data["userRegion"] = data["address"][2]; // 区
    data["userCode"] = sectioValue.get("acount");
    post(allUrl.register.upladeInfo, data, {
      "Content-Type": "application/json;charset=UTF-8",
      "Captcha-Code": this.props.form.getFieldValue("imageCode"),
      "Captcha-Key": this.state.imageKey.imageKey,
    })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          Toast.success("修改成功", 1, () => {
            this.props.history.goBack();
            tool.remove("userInfoData");
          });
        } else {
          Toast.fail(res.msg, 1, () => {
            this.getImageCode();
          });
        }
      })
      .catch((error) => {
        if (error.data && error.data.msg) {
          Toast.fail(error.data.msg, 1, () => {
            this.getImageCode();
          });
        } else {
          Toast.fail("修改失败，请重试", 1, () => {
            this.getImageCode();
          });
        }
      });
  };
  // 注册新用户
  submitData = (data) => {
    const { applyType } = this.state;
    data["userSexVal"] = data.userSex == "1" ? "男" : "女"; // 男或女
    data["userProvince"] = data["address"][0]; // 省
    data["userCity"] = data["address"][1]; // 市
    data["userRegion"] = data["address"][2]; // 区
    data["applyType"] = applyType;
    console.log("准备开始注册了");
    post(allUrl.register.userRegister, data, {
      "Content-Type": "application/json;charset=UTF-8",
      "Captcha-SMS-Code": this.props.form.getFieldValue("phoneCode"),
    })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          Toast.success(applyType == "reg" ? "注册成功" : "重置成功", 1, () => {
            this.props.history.push("/");
          });
        } else {
          Toast.fail(res.msg, 1, () => {
            this.getImageCode();
          });
        }
      })
      .catch((error) => {
        Toast.fail((error.data && error.data.msg) || "注册失败", 1, () => {
          this.getImageCode();
        });
      });
  };
  // 密码和确认密码
  compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue("userPassword")) {
      callback("您输入的密码不一致");
    } else {
      callback();
    }
  };
  componentDidMount() {
    const { location } = this.props;
    this.setState({
      applyType: location && location.state ? location.state.type : "",
    });
    // this.getDocType();
    this.getCityData();
    this.getQuestion();
    this.getJobData();
    this.getImageCode();
    this.getUserType();
  }
  //获取个人信息
  getUserinfo = async () => {
    let userCode = sectioValue.get("acount");
    let userData;
    userData = tool.get("userInfoData");
    this.setState({ type: userCode ? "edit" : "register" });
    if (!userCode) return;
    if (userCode && !userData) {
      userData = await userInfoData();
    }
    let nationVal = nation_data.filter((item) => {
      return item.label == userData.userNational;
    });
    let userJobVal = this.state.jobData.filter((item) => {
      return item.label == userData.userJob;
    });
    console.log(userJobVal, "拿到的个人职业");
    if (nationVal.length > 0) userData["userNationalVal"] = nationVal[0].value;
    if (userJobVal.length > 0) userData["userJobVal"] = userJobVal[0].value;

    this.setState({ userInfoData: userData });
  };
  // 获取城市数据
  getCityData = async () => {
    let data = await getCity();
    this.setState({ cityData: data });
  };
  // 获取证件类型
  getDocType = async () => {
    let data = await getDocType();
    this.setState({ docType: data });
  };
  // 获取人员类型数据
  getUserType = async () => {
    let data = await getUserType();
    this.setState({ getUserType: data });
  };
  // 获取密保问题
  getQuestion = async () => {
    let data = await getQuestion();
    console.log(data, "密保问题数据");
    this.setState({ questionData: data });
  };
  // 获取职业数据
  getJobData = async () => {
    let data = await getJobData();
    this.setState({ jobData: data });
    await this.getUserinfo();
  };
  // 点击日期确定
  rickPeng = (val) => {
    const { setFields } = this.props.form;
    setFields({
      userBrith: {
        value: val,
        errors: [new Error("未满18周岁")],
      },
    });
  };
  // 出生日期进行校验
  compareInitDate = (rule, value, callback) => {
    let YeadTime = moment().subtract(18, "years");
    if (value && value > YeadTime) {
      callback("未满18周岁");
    } else {
      callback();
    }
  };
  render() {
    const { getFieldProps, getFieldError, resetFields } = this.props.form;
    const { count, flagCode, userInfoData, type } = this.state;
    return (
      <div className="register-wrap">
        <form>
          <List style={{ paddingTop: "0px" }}>
            <InputItem
              {...getFieldProps("userName", {
                initialValue:
                  userInfoData && userInfoData.userName
                    ? userInfoData.userName
                    : "",
                rules: [{ required: true, message: "请输入真实姓名" }],
              })}
              clear
              error={!!getFieldError("userName")}
              onErrorClick={() => {
                alert(getFieldError("userName").join("、"));
              }}
              disabled={type == "register" ? false : true}
              placeholder="请输入真实姓名"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 姓名
            </InputItem>
            <Picker
              data={GenderData}
              cols={1}
              {...getFieldProps("userSex", {
                initialValue:
                  userInfoData && userInfoData.userSex
                    ? userInfoData.userSex.split(",")
                    : ["1"],
              })}
              disabled={type == "register" ? false : true}
              title="选择性别"
              labelNumber={8}
            >
              <List.Item
                arrow="horizontal"
                disabled={type == "register" ? false : true}
              >
                <span style={{ color: "red" }}>*</span> 性别
              </List.Item>
            </Picker>
            <Picker
              data={this.state.docType}
              cols={1}
              {...getFieldProps("idType", {
                initialValue:
                  userInfoData && userInfoData.idType
                    ? userInfoData.idType.split(",")
                    : ["01"],
                rules: [
                  {
                    required: true,
                    message: "请选择证件类型",
                  },
                ],
              })}
              disabled={type == "register" ? false : true}
              title="选择证件类型"
              labelNumber={8}
              maxLength={50}
            >
              <List.Item
                arrow="horizontal"
                disabled={type == "register" ? false : true}
              >
                <span style={{ color: "red" }}>*</span> 证件类型
              </List.Item>
            </Picker>
            <InputItem
              {...getFieldProps("idNumber", {
                initialValue:
                  userInfoData && userInfoData.idNumber
                    ? userInfoData.idNumber
                    : "",
                rules: [
                  { required: true, message: "请输入身份证号" },
                  {
                    required: false,
                    pattern: new RegExp(
                      /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                      "g"
                    ),
                    message: "请输入正确的身份证号",
                  },
                  {
                    validator: this.validateIdVal,
                  },
                ],
              })}
              clear
              error={!!getFieldError("idNumber")}
              disabled={type == "register" ? false : true}
              placeholder="请输入身份证号"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 身份证号
            </InputItem>
            <Picker
              data={this.state.cityData}
              cols={3}
              {...getFieldProps("address", {
                initialValue:
                  userInfoData && userInfoData.regionCodeArr
                    ? userInfoData.regionCodeArr
                    : "",
                rules: [
                  {
                    required: true,
                    message: "请选择地址",
                  },
                ],
              })}
              title="选择住址"
            >
              <List.Item arrow="horizontal">
                <span style={{ color: "red" }}>*</span> 住址
              </List.Item>
            </Picker>
            <InputItem
              {...getFieldProps("userAddress", {
                initialValue:
                  userInfoData && userInfoData.userAddress
                    ? userInfoData.userAddress
                    : "",
                rules: [{ required: true, message: "请输入详细地址" }],
              })}
              clear
              error={!!getFieldError("userAddress")}
              onErrorClick={() => {
                alert(getFieldError("userAddress").join("、"));
              }}
              placeholder="请输入详细地址"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 详细地址
            </InputItem>
            {type == "register" ? (
              <InputItem
                {...getFieldProps("userPassword", {
                  // initialValue: 'little ant',
                  rules: [
                    { required: true, message: "请输入密码" },
                    {
                      required: false,
                      pattern: new RegExp(
                        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                        "g"
                      ),
                      message: "请输入正确的密码",
                    },
                  ],
                })}
                clear
                type="password"
                error={!!getFieldError("userPassword")}
                placeholder="密码长度8-16位,必须包含字母和数字"
                labelNumber={8}
                maxLength={50}
              >
                <span style={{ color: "red" }}>*</span> 密码
              </InputItem>
            ) : null}
            {type == "register" ? (
              <InputItem
                {...getFieldProps("confirm", {
                  // initialValue: 'little ant',
                  rules: [
                    { required: true, message: "请再次输入密码" },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })}
                type="password"
                clear
                error={!!getFieldError("confirm")}
                placeholder="请再次输入密码"
                labelNumber={8}
                maxLength={50}
              >
                <span style={{ color: "red" }}>*</span> 确认密码
              </InputItem>
            ) : null}
            {type == "register" ? (
              <Picker
                data={this.state.questionData}
                cols={1}
                {...getFieldProps("pwdQuestionOne", {
                  initialValue: "",
                  rules: [{ required: true, message: "请选择密保问题" }],
                })}
                title="选择密保问题"
              >
                <List.Item arrow="horizontal">
                  <span style={{ color: "red" }}>*</span> 密保问题
                </List.Item>
              </Picker>
            ) : null}
            {type == "register" ? (
              <InputItem
                {...getFieldProps("pwdAnswerOne", {
                  // initialValue: 'little ant',
                  rules: [{ required: true, message: "请输入密保答案" }],
                })}
                clear
                error={!!getFieldError("pwdAnswerOne")}
                onErrorClick={() => {
                  alert(getFieldError("pwdAnswerOne").join("、"));
                }}
                placeholder="请输入密保答案"
                labelNumber={8}
                maxLength={50}
              >
                <span style={{ color: "red" }}>*</span> 密保答案
              </InputItem>
            ) : null}

            <DatePicker
              {...getFieldProps("userBrith", {
                initialValue:
                  userInfoData && userInfoData.userBrith
                    ? moment(userInfoData.userBrith)["_d"]
                    : this.state.date,
                rules: [],
              })}
              mode="date"
              minDate={minDate}
              title="选择出生日期"
              extra="Optional"
              onOk={this.rickPeng}
              disabled={true}
              // onChange={(date) => this.setState({ date })}
            >
              <List.Item arrow="horizontal">出生日期</List.Item>
            </DatePicker>
            <Picker
              data={nation_data}
              cols={1}
              {...getFieldProps("userNational", {
                initialValue:
                  userInfoData && userInfoData.userNationalVal
                    ? [`${userInfoData.userNationalVal}`]
                    : ["1"],
                rules: [{ required: true, message: "请选择民族" }],
              })}
              title="选择民族"
            >
              <List.Item arrow="horizontal">
                <span style={{ color: "red" }}>*</span> 民族
              </List.Item>
            </Picker>
            <Picker
              data={this.state.getUserType}
              cols={1}
              {...getFieldProps("teamTypeParent", {
                initialValue:
                  userInfoData && userInfoData.teamTypeParent
                    ? [`${userInfoData.teamTypeParent}`]
                    : [],
                rules: [{ required: true, message: "请选择人员类型" }],
              })}
              title="选择人员类型"
            >
              <List.Item arrow="horizontal">
                <span style={{ color: "red" }}>*</span> 人员类型
              </List.Item>
            </Picker>
            <Picker
              data={this.state.jobData}
              cols={1}
              {...getFieldProps("userJob", {
                initialValue:
                  userInfoData && userInfoData.userJobVal
                    ? userInfoData.userJobVal.split(",")
                    : "",
                rules: [{ required: false, message: "请选择职业" }],
              })}
              title="选择职业"
            >
              <List.Item arrow="horizontal">职业</List.Item>
            </Picker>
            {formInputData.map((item) => {
              return (
                <div key={item.type}>
                  <InputItem
                    {...getFieldProps(item.type, {
                      initialValue:
                        userInfoData && userInfoData[item.type]
                          ? userInfoData[item.type]
                          : "",
                      rules: [
                        { required: false, message: item.errorText },
                        {
                          required: false,
                          pattern: new RegExp(item.reg, "g"),
                          message: item.errorText,
                        },
                      ],
                    })}
                    clear
                    placeholder={item.placeholder}
                    error={!!getFieldError(item.type)}
                    labelNumber={8}
                    maxLength={50}
                  >
                    {item.name}
                  </InputItem>
                </div>
              );
            })}
            <InputItem
              {...getFieldProps("phoneNumber", {
                initialValue:
                  userInfoData && userInfoData.phoneNumber
                    ? userInfoData.phoneNumber
                    : "",
                rules: [
                  { required: true, message: "请输入手机号码" },
                  {
                    required: false,
                    pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/, "g"),
                    message: "请输入正确的手机号",
                  },
                ],
              })}
              disabled={type == "register" ? false : true}
              clear
              error={!!getFieldError("phoneNumber")}
              onErrorClick={() => {
                alert(getFieldError("phoneNumber").join("、"));
              }}
              placeholder="请输入手机号码"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 手机号码
            </InputItem>
            <div style={{ position: "relative" }}>
              <InputItem
                {...getFieldProps("imageCode", {
                  rules: [{ required: true, message: "请输入图片验证码" }],
                })}
                placeholder="请输入图片验证码"
                type=""
                labelNumber={8}
                maxLength={50}
              >
                <span style={{ color: "red" }}>*</span> 图片验证码
              </InputItem>
              <div
                className="code-image"
                onClick={() => {
                  this.getImageCode();
                }}
              >
                <img src={this.state.imageKey.imageUrl || ""}></img>
              </div>
            </div>
            {type == "register" ? (
              <div className="item-percont">
                <InputItem
                  {...getFieldProps("phoneCode", {
                    // initialValue: 'little ant',
                    rules: [{ required: true, message: "请输入验证码" }],
                  })}
                  clear
                  placeholder="请输入验证码"
                  labelNumber={8}
                  maxLength={6}
                >
                  <span style={{ color: "red" }}>*</span> 验证码
                </InputItem>
                <div
                  className="code-phone"
                  onClick={() => {
                    this.catchapCode();
                  }}
                  style={{
                    color: flagCode ? "#337fd3" : "#ccc",
                    borderColor: flagCode ? "#337fd3" : "#ccc",
                  }}
                >
                  {flagCode ? "获取验证码" : `${count}S重新获取`}
                </div>
              </div>
            ) : null}
          </List>
          <Item>
            <div className="footer-btn">
              <Button type="primary" inline onClick={this.onSubmit}>
                提交
              </Button>
              <Button
                type="ghost"
                inline
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                取消
              </Button>
            </div>
          </Item>
        </form>
      </div>
    );
  }
}
export default createForm()(Register);
